import {ApiRes} from '../../types/api'
import {API_URL, apiGet, apiPost, dataGet} from '../api'
import {IOrder} from '../unknownorder/nft'
import {IAsset, ILatestBalance} from '../user/getKeyProfile'

export interface IAbnormal {
    key_id: string
    prev_balance: ILatestBalance
    next_balance: ILatestBalance
    orders: IOrder[]
    yesterday_total: number
    today_total: number
    unknown_transfer: IUnknownTransfer
    added_at: string
}

export interface IUnknownTransfer {
    _id: string
    key_id: string
    status: string
    amounts: IAmountDiffer[]
    added_at: string
}

export interface IAmountDiffer {
    symbol: string
    amount: number
    size: number
    side: string
    added_at: string
}

export const getAbnormalList = async (current_page: number): Promise<ApiRes<IUnknownTransfer[]>> => {
    return await apiGet(API_URL, `admin/unknown_transfers?current_page=${current_page}&page_size=10`)
}

export const getAbnormal = async (id: string): Promise<ApiRes<IAbnormal>> => {
    return await dataGet(API_URL, `admin/unknown_transfer/${id}`)
}

export interface IAbnormalMark {
    key_id: string
    symbol: string
    amount: number
    added_at: string
}

export const postAbnormal = async (body: IAbnormalMark) => {
    return await apiPost(API_URL, `admin/unknown_transfer/mark`, body)
}
